import { Flex } from 'antd';
import UpdateButton from './UpdateButton';

const FormSubmitButton = ({ activate = false, detail }) => {
	return (
		<Flex justify="flex-end" align="flex-end">
			<UpdateButton title={detail ? 'Update' : 'Submit'} disabled={activate} />
		</Flex>
	);
};

export default FormSubmitButton;
